/*
  Card swatches interactivity för collection-grid.

  Klick på en swatch:
  - Byter card-mediats primär + sekundär img (src/srcset/alt)
  - Uppdaterar kort-länkarna till ?variant=id så efterföljande klick på kortet
    leder till vald variant på PDP
  - Markerar swatch:en med aria-current
  - Navigerar EJ direkt - användaren klickar kortet för att gå till produkten

  Swatches renderas som sibling till .card-wrapper inuti .grid__item (se
  sections/main-collection-product-grid.liquid) så Dawn:s wrapper-hover-swap
  inte triggas av swatch-hover.
*/

(function () {
  if (window.__cardSwatchesInit) return;
  window.__cardSwatchesInit = true;

  document.addEventListener('click', function (event) {
    const swatch = event.target.closest('.card-swatch');
    if (!swatch) return;

    event.preventDefault();

    const gridItem = swatch.closest('.grid__item');
    const card = gridItem && gridItem.querySelector('.card-wrapper');
    if (!card) return;

    // Byt primär + sekundär bild. querySelectorAll med index är mer robust mot
    // whitespace mellan img-elementen i Liquid-output än child-selektorer.
    const mediaImgs = card.querySelectorAll('.card__media .media > img');
    const primaryImg = mediaImgs[0];
    const secondaryImg = mediaImgs[1];

    const imageSrc = swatch.dataset.imageSrc;
    if (imageSrc && primaryImg) {
      primaryImg.src = imageSrc;
      if (swatch.dataset.imageSrcset) primaryImg.srcset = swatch.dataset.imageSrcset;
      if (swatch.dataset.imageAlt) primaryImg.alt = swatch.dataset.imageAlt;
    }

    const secSrc = swatch.dataset.secondarySrc;
    if (secSrc && secondaryImg) {
      secondaryImg.src = secSrc;
      if (swatch.dataset.secondarySrcset) secondaryImg.srcset = swatch.dataset.secondarySrcset;
      if (swatch.dataset.secondaryAlt) secondaryImg.alt = swatch.dataset.secondaryAlt;
    }

    // Uppdatera card-länkar till variant-URL:en
    const variantUrl = swatch.dataset.variantUrl;
    if (variantUrl) {
      card.querySelectorAll('a[href]').forEach(function (link) {
        link.href = variantUrl;
      });
    }

    // aria-current toggle på alla swatches i grid_item
    gridItem.querySelectorAll('.card-swatch').forEach(function (s) {
      s.removeAttribute('aria-current');
    });
    swatch.setAttribute('aria-current', 'true');

    // Nyhet-badge följer vald färg (bara i per-color-läge): visa om vald färg
    // är ny, dölj annars. Helt nya produkter (ingen data-nyhet-percolor) rörs ej.
    updateNyhetBadge(card, swatch.closest('.card-swatches'), swatch);

    // Blur så focus-state inte stannar kvar på klickad knapp
    swatch.blur();
  });

  // Visa/dölj kortets Nyhet-badge baserat på om den valda swatchen är ny.
  // Endast i per-color-läge (containern har data-nyhet-percolor). Helt nya
  // produkter saknar attributet → badgen lämnas orörd (alltid synlig).
  function updateNyhetBadge(card, swatchesEl, activeSwatch) {
    if (!card || !swatchesEl || !swatchesEl.dataset.nyhetPercolor) return;
    const badge = card.querySelector('.badge--nyhet');
    if (!badge) return;
    badge.style.display = activeSwatch && activeSwatch.dataset.isNew ? '' : 'none';
  }
})();
